import React from 'react';
import { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import Header from '../../components/header';
import Footer from '../../components/footer';
import Head from '../../components/head';
import ListEstagiarios from '../../components/rh/estagiarios';


function EstagiariosScreen() {
    return (
        <Fragment>
            <Head titulo="Listagem de Estagiários da Prefeitura de Macuco" />
            <Header />
            <Container>
                <ListEstagiarios />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default EstagiariosScreen;